import PagebuilderHighlightsGrid from 'gatsby-theme-pagebuilder/src/components/blocks/highlights/buttons/grid';

export default PagebuilderHighlightsGrid;
